module.exports = __webpack_public_path__ + "static/media/headshot.20b4c835.jpg";